import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  Input,
  AfterViewInit,
  Type,
  ChangeDetectorRef,
  TemplateRef,
} from "@angular/core";
import { Router, ActivatedRoute, NavigationStart } from "@angular/router";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { HttpCalendarService } from "@root/component/multi-calendar/http-calendar.service";
import { CalendarBuilder } from "@root/component/multi-calendar/multi-calendar.service";
import { HouseStatusService } from "@root/router/deprecated_and_do_not_use-house/house-status/house-status.service";
import { StoreService } from "@root/shared/service/store.service";
// import { AuthorityService } from '@root/shared/business-sevice/authority.service';
import { HouseStatusSettingService } from "@root/router/setting/custom-config/house-status-setting.service";
import { TaskCleanService } from "@root/router/deprecated_and_do_not_use-task/task-clean/task-clean.service";
import { ReadOrdersComponent } from "@root/component/read-orders/read-orders.component";

import { map, tap, distinctUntilChanged, takeUntil, skip, first, filter, combineAll, switchMap } from "rxjs";
import _, { groupBy, head, isEmpty, keyBy, last, mapValues, range } from "lodash";
import * as moment from "moment";
import { Moment } from "moment";
import { Subject, from, empty } from "rxjs";
import { SystemService } from "@root/router/system/system.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { TranslateService } from "@root/shared/service/translate.service";
import { IndexService } from "@root/router/index/index.service";
import { DateService } from "@root/shared/service/date.service";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { ContinueStayComponent } from "@root/router/component/house-order-detail/house-order-basic/continue-stay/continue-stay.component";
import { ModalService } from "@root/router/index/modal.service";
import { AppService } from "@root/app.service";
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from "@angular/forms";
import { NzDrawerService } from "ng-zorro-antd/drawer";
import { TaskDetailComponent } from "@root/router/component/task/task-detail/task-detail.component";
import { CacheService } from "@delon/cache";
import { NewComerPromotionService } from "@root/router/component/other/new-comer-promotion/new-comer-promotion.service";
import { HeaderOutletComponent } from "@root/layout/header-outlet/header-outlet.component";
import { HeaderOutletService } from "@root/layout/header-outlet/header-outlet.service";
import { NoDataService, Page } from "@root/service/no-data.service";
import { HttpClient } from "@angular/common/http";
import { ACLService } from "@delon/acl";
import { HouseOrderboxComponent } from "../house-orderbox/house-orderbox.component";
import { HouseTodayComponent } from "../house-today/house-today.component";
import { HouseTomorrowComponent } from "../house-tomorrow/house-tomorrow.component";
import { Parent, MultiHouseCalendarService } from "../multi-house-calendar/multi-house-calendar.service";
import { OperateBarComponent } from "../operate-bar/operate-bar.component";
import { V4HousesModalSelectComponent } from "../../v4/houses-modal-select/houses-modal-select.component";
import { ShareLinkComponent } from "../share-link/share-link.component";
import { CalendarLayoutService } from "../calendar-layout/calendar-layout.service";

interface ICalendarMap {
  [houseId: string]: {
    [date: string]: any;
  };
}
interface IReservationMap {
  [houseId: string]: any[];
}

type FilterField = "keyword" | "group" | "type" | "cleanStatus" | "houseStatus" | "todayInfo";

@Component({
  selector: "host-hostex-status",
  templateUrl: "./hostex-status.component.html",
  styleUrls: ["./hostex-status.component.scss"],
})
export class HostexStatusComponent implements OnInit, AfterViewInit, OnDestroy {
  type = "hostex";
  calendarType: "complex" | "simple" = "complex";
  @Input() showHeader = true;
  @Input("houseTypeId")
  set currentHouseTypeId(value) {
    if (value) {
      // this.filterForm.patchValue({ type_ids: ['type', [+value]] });
      this.filterForm.patchValue({ house_type_id: +value });
    }
  } // 外部传的值与筛选框里的选值共同使用这一个字段

  @ViewChild("promotionTpl") promotionTpl: TemplateRef<any>;
  @ViewChild("calendar") calendar;
  listOfTodayInfo = [];
  listOfHouses: Parent[] = this.getCachedFirstScreenRenderData() || this.generateFakeSkeletonData() || [];
  // listOfThirdpartieOptions = [];
  listOfAllMonthOptions = [];
  listOfSubaccounOptions = [];
  selectStatus = {
    status: "none",
    dates: null,
  };
  totalHouseCount = 0;
  currentPage = 1;
  filterForm: UntypedFormGroup = this.fb.group({
    title: null,
    house_cleaning_status: null,
    physical_status: null,
    today_status: null,
    operator_relation_id: null,
    // type_ids: null,
    house_type_id: null,
    group_id: null,
    // =====
    month: moment().format("YYYY-MM"),
  });
  widgetCount = {
    today_task_count: 0,
    tomorrow_task_count: 0,
    box_count: 0,
  };
  disableDisplayICal = !!this.storeService.get("hostex_disable_display_ical", 2);
  // disableDisplayTip = !!this.storeService.get('hostex_disable_display_tip', 2);
  displayPagination = false;
  displayLeadPrice: boolean = this.getCachedLeadView("price");
  displayLeadRules: boolean = this.getCachedLeadView("rules");
  reservationStyle: "status" | "channel" = "status";
  pageSize = 30;
  couldRender = false;
  notCreateHouse = false; // 还未创建房间。显示未创建房间的空页面

  hostexSiderbarDrawerRef;
  hourResvDrawerRef;
  resvDetailDrawerRef;

  private headerOutletInstance: HeaderOutletComponent<OperateBarComponent>;
  readonly cellWidth = 58;
  readonly cellHeight = 74;

  // orderPageInfo = null;

  private begin = moment().subtract(3, "days").format("YYYY-MM-DD");
  private end = moment().add(1, "month").format("YYYY-MM-DD");
  private scroll$ = this.houseCalendarService.dateChangeRaw$.pipe(
    tap((value) => {
      this.begin = _.head(value);
      this.end = _.last(value);
      // this.currentMonth = moment(this.begin).format("YYYY-MM");
      this.filterForm.patchValue(
        {
          month: moment(this.begin).format("YYYY-MM"),
        },
        { emitEvent: false },
      );
    }),
  );
  private calendarInit$ = this.scroll$.pipe(first());
  private restScroll$ = this.scroll$.pipe(skip(1));
  private calendarRefresh$ = this.houseCalendarService.calendarRefreshRaw$;
  private scrollRaw$ = this.houseCalendarService.scrollRaw$;

  private selectedResv$ = this.houseCalendarService.selectReservationRaw$.pipe(
    tap((code) => {
      if (code) {
        this.resvDetailDrawerRef = this.globalModalService.displayResvDetailDrawer(code, this.resvDetailDrawerRef);

        this.houseCalendarService.cancelSelect();
      } else {
        this.resvDetailDrawerRef?.close();
      }
    }),
  );

  private selected$ = this.houseCalendarService.selectRaw$.pipe(
    // filter(v => v.dates.type !== 'type'),
    tap((value) => {
      console.log("value: ", value);
      this.type = "hostex";

      this.selectStatus = value;

      if (value.status === "done") {
        this.hostexSiderbarDrawerRef = this.globalModalService.displayHostexSidebar();
      } else {
        this.hostexSiderbarDrawerRef?.close();
        this.hourResvDrawerRef?.close();
      }

      if (value.status !== "none") {
        this.houseCalendarService.cancelSelectReservation();
        // this.selectedReservation = null;
      }
    }),
  );
  private hourReservationSidebar$ = this.houseCalendarService.hourReservationRaw$.pipe(
    tap((value) => {
      this.hostexSiderbarDrawerRef?.close();

      this.type = "hour-reservation";

      this.hourResvDrawerRef = this.globalModalService.displayHourResvSidebar();
    }),
  );

  private selectTask$ = this.houseCalendarService.selectTaskRaw$.pipe(
    tap((value) => {
      // this.selectedTask = value;

      if (value) {
        this.displayTaskDetailDrawer(value);
        this.houseCalendarService.cancelSelectReservation();
      }
    }),
  );

  private filterRaw$ = new Subject<{
    field: FilterField;
    value: any;
  }>();

  private dateFormatChange$ = this.dateSrv.dateFormatChange$.pipe(
    tap(() => {
      this.setMonthOptions();
      // this.listOfAllMonthOptions = this.calendarService.getAllMonth();
    }),
  );

  // private currentOrderPageRaw$ = this.switchPageService.currentNodeRaw$.pipe(
  //   tap((value) => {
  //     this.orderPageInfo = value;
  //   })
  // );

  private destroy$ = new Subject();
  calendarMap: ICalendarMap = {};
  reservationMap: IReservationMap = {};
  hourReservationMap = {};
  taskMap = {};
  freeHouseCountMap = {};
  freeHouseCountMapByType = {};
  housesPriceMap = {};
  housesOversaleMap = {};
  // housesCleanInfoMap = {};
  reservationChannelMap = {};
  listOfCachedReservation = {};
  listOfCachedHourReservation = {};
  listOfCachedTask = {};
  inventoryDiffMap = {};

  private createTaskDrawerRef;

  get searching(): boolean {
    return _.some(_.omit(this.filterForm.value, "month"), (v) => !_.isNil(v));
  }

  get international() {
    return this.app.app.international;
    // return this.internationalService.isInternational();
  }

  get displayPromotion() {
    return this.ncpSrv.dispalyNewComerPromotion;
  }

  get isSubaccount() {
    return this.acl.can({ role: ["slave"] });
  }

  constructor(
    public router: Router,
    private http: HttpClient,
    private acl: ACLService,
    private route: ActivatedRoute,
    private httpService: HttpCalendarService,
    private storeService: StoreService,
    private calendarService: CalendarBuilder,
    private houseCalendarService: MultiHouseCalendarService,
    private statusService: HouseStatusService,
    private modal: NzModalService,
    private commonConfigService: HouseStatusSettingService,
    // private authorityService: AuthorityService,
    private changeDetector: ChangeDetectorRef,
    private systemService: SystemService,
    private taskCleanService: TaskCleanService,
    private orderService: OrderV2Service,
    private t: TranslateService,
    private dateSrv: DateService,
    private indexService: IndexService,
    private globalModalService: ModalService,
    private drawer: NzDrawerService,
    private app: AppService,
    private cacheSrv: CacheService,
    private fb: UntypedFormBuilder,
    private ncpSrv: NewComerPromotionService,
    private headerOutletSrv: HeaderOutletService,
    private noDataSrv: NoDataService,
    private layoutSrv: CalendarLayoutService,
  ) {
    // this.initCacheStrategy();
  }

  ngOnInit() {
    this.indexService.displayLoading();
    this.init();
    this.setMonthOptions();
    // this.currentOrderPageRaw$.pipe(takeUntil(this.destroy$)).subscribe();

    this.subscribeFormChange();

    this.noDataSrv.frontHideDemo(Page.Calendar);
  }

  ngAfterViewInit() {
    this.checkNewComerPromotion();
    // this.fetchCommonConfig();

    if (this.showHeader) {
      this.createComponentInHeaderOutlet();
    }
  }

  private createComponentInHeaderOutlet() {
    console.log("start create component in header outlet");
    this.headerOutletSrv.containerRefInit$
      .pipe(
        filter((init) => init),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        console.log("===== after container ref init");
        const headerOutlet = this.headerOutletSrv.getInstance<OperateBarComponent>();
        headerOutlet.createComponent(OperateBarComponent, {
          listOfMonthOptions: this.listOfAllMonthOptions,
          form: this.filterForm,
          type: "status",
        });

        this.headerOutletInstance = headerOutlet;
        // const instance = cmp.instance;

        // instance.form = this.filterForm;
        // instance.listOfMonthOptions = this.listOfAllMonthOptions;
        // instance.listOfTodayInfoOptions = this.listOfTodayInfo;
      });
  }

  private subscribeFormChange() {
    let monthFlag = false; // @todo 优化逻辑
    this.filterForm.valueChanges.subscribe((rst) => {
      console.log("form change: ", rst);
      if (monthFlag) {
        monthFlag = false;
      } else {
        this.currentPage = 1;
        this.fetchHouseAndCalendar();
      }
    });
    this.filterForm.get("month").valueChanges.subscribe((rst) => {
      console.log("month change: ", rst);
      monthFlag = true;
      this.scroll(rst);
    });
  }

  private checkNewComerPromotion() {
    const displayed = this.cacheSrv.getNone("host_displayed_4.0.1_new_comer_promotion");
    if (this.ncpSrv.canDisplay() && !displayed) {
      this.ncpSrv.displayPromotion();

      this.cacheSrv.set("host_displayed_4.0.1_new_comer_promotion", true);
    }
    // if (!displayed && this.memberSrv.hasNewComerPromotion) {
    //   this.displayNewComerPromotion = true;

    // }
  }

  private init() {
    this.currentPage = 1;
    this.dateFormatChange$.pipe(takeUntil(this.destroy$)).subscribe();

    /** 刷新日历 */
    this.calendarRefresh$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.fetchFreeHouseCountByHouseType();
      this.fetchCalendarV3();
      // await this.fetchHouseAndCalendar();
      this.fetchInventoryDiffInfo();
    });

    /** 选中订单 */
    this.selectedResv$.pipe(takeUntil(this.destroy$)).subscribe();

    /** 选中日历 */
    this.selected$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      // log('$selected');
    });
    /** 选中小时单 */
    this.hourReservationSidebar$.pipe(takeUntil(this.destroy$)).subscribe();

    this.selectTask$.pipe(takeUntil(this.destroy$)).subscribe();

    /**
     * 日历滚动时会触发两种事件：calendarInit$ 和 restscroll$
     * 因为两次的处理逻辑不同，所以分开处理
     * 第一次滚动时触发calendarInit
     * 其余的滚动触发restscroll
     */
    this.calendarInit$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // this.fetchFreeHouseCountByHouseType();
      // this.requestCommonConfig()
      //   .pipe(switchMap(() => this.requestHouseList()))
      //   .subscribe(() => {
      //     this.fetchCalendarV3();
      //     this.fetchInventoryDiffInfo();
      //     this.fetchCleanInfo();
      //     this.fetchOversaleInfo();
      //     this.updateDisplayPagination();
      //   });
      // this.systemService.checkIfShowSystemAlert();
    });

    this.restScroll$.pipe(takeUntil(this.destroy$)).subscribe((dates) => {
      this.fetchCalendarV3();
      // this.fetchCalendarList();
      this.fetchFreeHouseCountByHouseType();
      this.fetchInventoryDiffInfo();
    });

    this.requestCommonConfig()
      .pipe(switchMap(() => this.requestHouseList()))
      .subscribe(() => {
        this.fetchCalendarV3();
        this.fetchInventoryDiffInfo();
        // this.fetchCleanInfo();
        this.fetchOversaleInfo();

        // this.updateDisplayPagination();
      });

    this.systemService.checkIfShowSystemAlert();
    this.fetchFreeHouseCountByHouseType();
    this.fetchWidgetCount();
    this.fetchTodayInfo();

    if (!this.isSubaccount) {
      this.fetchSubaccountList();
    }
  }

  private setMonthOptions() {
    const list = this.calendarService.getAllMonth();
    this.listOfAllMonthOptions = list.map((item) => ({
      label: item.i18nTitle,
      value: item.date,
    }));
    console.log("month options: ", this.listOfAllMonthOptions);
  }

  private initCacheStrategy() {
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((res: NavigationStart) => {
      if (res.url !== "/app/calendar") {
        /** 跳转到其他页面，本页面缓存，销毁订阅 */
        this.destroy$.next(null);
        this.destroy$.complete();
      } else {
        /**
         * 跳转回本页面，重新订阅，重新初始化，滚动触发
         * 之所以重新订阅是为了保持初始化逻辑的统一
         * */
        this.destroy$ = new Subject();
        this.init();

        let timer = setTimeout(() => {
          this.calendar.scroll(363);

          clearTimeout(timer);
          timer = null;
        });
      }
    });
  }

  private generateFakeSkeletonData(): Parent[] {
    return [
      {
        r_type: "group",
        p_id: 1,
        p_type: 1,
        p_title: "Loading data ... ",
        p_stop_auto_managed: false,
        p_children: range(0, 30).map((i) => ({
          c_id: i,
          c_title: "Loading data ... ",
          c_cover_url: null,
          c_parent: null,
          c_cleaning_status: 1,
          c_stop_auto_managed: false,
          r_type: "member",
        })),
        p_children_ids: range(0, 20).map((i) => i),
      },
    ];
  }

  private requestCommonConfig() {
    // const res = await this.commonConfigService.getSettings().toPromise();
    // const channels = _.get(res, "data.reservation_channel") || [];
    // const reservationStyle = _.get(res, "data.house_status_setting.reservation_style") || 0;
    // const pageSize = _.get(res, "data.house_status_setting.house_status_page_size") || 30;

    // this.pageSize = pageSize;

    // this.updateReservationStyle(reservationStyle);
    // this.updateChannelColorMap(channels);

    return this.commonConfigService.getSettings().pipe(
      tap((rst) => {
        const channels = rst?.data.reservation_channel || [];
        const reservationStyle = rst?.data.house_status_setting.reservation_style || 0;
        const pageSize = rst?.data.house_status_setting.house_status_page_size || 30;

        this.pageSize = pageSize;

        this.updateReservationStyle(reservationStyle);
        this.updateChannelColorMap(channels);
      }),
    );
  }

  private requestHouseList() {
    const value = this.filterForm.value;

    const params = {
      page: this.currentPage,
      page_size: this.pageSize,
      version: "2.4",
      type: "house_status",
      ..._.omit(value, ["month"]),
    };

    if (value.house_type_id) {
      Object.assign(params, { house_type_id: JSON.stringify(value.house_type_id) });
    }

    if (value.group_id) {
      Object.assign(params, { group_id: JSON.stringify([value.group_id]) });
    }

    return this.httpService.getHouseListV2(params).pipe(
      tap((res) => {
        if (res.error_code === -1) {
          this.notCreateHouse = true;
        } else {
          this.notCreateHouse = false;
        }

        /** 房态 */
        const houseTypeMap = _.get(res, "data.house_type_map") || [];
        const houseList = _.get(res, "data.list") || [];
        const total = _.get(res, "data.count");
        this.listOfHouses = this.updateHouseTypeMapList(houseTypeMap, houseList);
        this.totalHouseCount = total;
        if (this.currentPage === 1) {
          this.calendarType = _.find(houseTypeMap, (type) => type.house_type_id !== -1) ? "complex" : "simple";
        }
        console.log("listOfHouses: ", this.listOfHouses);
        /**
         * 避免搜索房源时触发弹窗条件
         */
        if (!this.searching) {
          this.checkIfHouseCountHasChanged();
        }

        if (this.currentPage === 1 && !this.searching) {
          this.cacheFirstScreenRenderData(this.listOfHouses);
          // this.cacheSrv.set('hostex-price-fp-data', this.listOfHouses);
        }

        this.indexService.dismissLoading();
        this.couldRender = true;
      }),
    );
  }

  private fetchOversaleInfo() {
    const ids = _.flattenDeep(this.listOfHouses.map((type) => type.p_children_ids));
    this.httpService.fetchOversaleInfo({ house_ids: JSON.stringify(ids) }).subscribe((res) => {
      const house_map = _.get(res, "data.house_map");
      const house_type_map = _.get(res, "data.house_type_map");
      this.updateHouseOversaleMap(house_map, house_type_map);
    });
  }

  // private fetchCleanInfo() {
  //   const ids = _.flattenDeep(this.listOfHouses.map((type) => type.p_children_ids));

  //   const page_size = this.pageSize;
  //   const begin = moment(this.begin).format("YYYY-MM-DD");
  //   const end = moment(this.end).format("YYYY-MM-DD");

  //   this.taskCleanService
  //     .getHouseList({
  //       begin,
  //       end,
  //       page_size,
  //       house_ids: JSON.stringify(ids),
  //     })
  //     .subscribe((res) => {
  //       const list = _.get(res, "data.list") || [];

  //       this.housesCleanInfoMap = _.keyBy(list, "id");
  //     });
  // }

  private fetchInventoryDiffInfo() {
    const houseTypeIds = this.listOfHouses.map((type) => type.p_id);
    const begin = this.begin;
    const end = this.end;

    if (!begin || !end) {
      return;
    }

    this.httpService
      .fetchInventoryDiffInfo({
        house_type_ids: JSON.stringify(houseTypeIds),
        begin,
        end,
      })
      .subscribe((res) => {
        const list = _.get(res, "data.list");
        this.updateInventoryDiffMap(list);
      });
  }

  private fetchHouseAndCalendar() {
    this.requestHouseList().subscribe(() => {
      this.fetchCalendarV3();
    });
    // await this.requestHouseList().toPromise();
    // // await this.requestCalendarList().toPromise();
    // this.fetchCalendarV3();
  }

  private fetchCalendarV3() {
    const ids = _.flattenDeep(this.listOfHouses.map((type) => type.p_children_ids));
    const begin = this.begin;
    const end = this.end;

    if (isEmpty(ids)) {
      return;
    }

    const paramsV3 = {
      house_ids: JSON.stringify(ids),
      begin,
      end,
      format: "only_lead_price",
    };

    this.httpService.fetchCalendarV3(paramsV3).subscribe((rst: any) => {
      const calendar = rst?.data?.list || [];
      const resvs = rst?.data?.reservations || [];
      const hourResvs = rst?.data?.hour_reservations || [];
      const tasks = rst?.data?.schedule_tasks || [];

      const map = this.generateCalendarMapV3(calendar);
      const resvMap = this.generateResvMapV4(resvs);
      const hourResvMap = this.generateHourResvMapV3(hourResvs);
      const taskMap = this.generateTaskMapV3(tasks);
      console.log("now map: ", map, " now resvs", resvMap, " now hour resv: ", hourResvMap, "now task: ", taskMap);
      this.calendarMap = map;
      this.reservationMap = resvMap;
      this.hourReservationMap = hourResvMap;
      this.taskMap = taskMap;
    });
  }

  /**
   * @return {
   *   house_type_id: {
   *    '2019-11-11': 3,
   *    ...
   *   }
   * }
   */
  private fetchFreeHouseCountByHouseType(): void {
    this.httpService
      .getFreeHouseCount({
        // group_id: this.currentGroup,
        begin: this.begin,
        end: this.end,
        version: "2.4",
      })
      .subscribe((res) => {
        const list = _.get(res, "data.list") || [];
        const totalList = _.get(res, "data.record") || [];
        this.updateFreeHouseCount(totalList);
        this.updateFreeHouseCountByType(list);
      });
  }

  private fetchWidgetCount() {
    this.statusService.getWidgetCount().subscribe((res) => {
      this.widgetCount = res.data || {};

      this.houseCalendarService.updateOrderBoxCount(this.widgetCount.box_count);
    });
  }

  private fetchTodayInfo() {
    this.httpService.fetchTodayInfo().subscribe((res) => {
      this.listOfTodayInfo = _.get(res, "data") || [];
      this.listOfTodayInfo.unshift({
        label: this.t.t("word.any_status"),
        value: null,
      });

      this.headerOutletInstance?.updateComponentInputData({
        listOfTodayInfoOptions: this.listOfTodayInfo,
      });
    });
  }

  /**
   * @todo @fixme
   * 考虑将这些选项的初始化放到operate-bar组件内部
   */
  private fetchSubaccountList() {
    const params = {
      page: 1,
      page_size: 10000,
      format: "house_filter",
    };
    this.http.get("/api/sub_account/list", { params }).subscribe((rst: HttpRsp) => {
      this.listOfSubaccounOptions = rst?.data?.list?.map((opt) => ({
        label: opt.principal || opt.account,
        value: opt.operator_relation_id,
      }));
      this.listOfSubaccounOptions.unshift({
        label: this.t.t("word.any"),
        value: null,
      });

      this.headerOutletInstance?.updateComponentInputData({
        listOfSubaccountOptions: this.listOfSubaccounOptions,
      });
    });
  }

  private requestSetHouseTypeInventory(params) {
    this.httpService.setHouseTypeInventory(params).subscribe((res) => {});
  }

  private requestAddNote(params) {
    return this.httpService.addNote(params);
  }

  private requestDeleteNote(params) {
    return this.httpService.deleteNote(params);
  }

  private requestUpdateCleanStatus(params) {
    const { id, status } = params;
    return this.taskCleanService.updateCleaningHouse({ house_id: id, status });
  }

  private checkIfHouseCountHasChanged() {}

  private cacheFirstScreenRenderData(data) {
    const key = "hostex.status_calendar_fp_data-" + this.storeService.get("operator_id");
    this.cacheSrv.set(key, data);
  }

  private getCachedFirstScreenRenderData(): any[] {
    const key = "hostex.status_calendar_fp_data-" + this.storeService.get("operator_id");
    return this.cacheSrv.getNone(key);
  }

  private cacheLeadView(view: "price" | "rules", value: boolean) {
    const key = "hostex.status_calendar_lead_view-" + view;
    this.cacheSrv.set(key, value);
  }

  private getCachedLeadView(view: "price" | "rules"): boolean {
    const key = "hostex.status_calendar_lead_view-" + view;
    return this.cacheSrv.getNone(key);
  }

  /**
   * @param typeList Array<any> 房型列表
   * @param houseList Array<any> 房子列表
   */
  private updateHouseTypeMapList(typeList = [], houseList = []): Parent[] {
    const houseMap = _.keyBy(houseList, "id");
    return typeList.map((type) => {
      const parent: Parent = this.houseCalendarService.generateStatusParentEntity(type);

      const children = type.house_ids.map((id) =>
        this.houseCalendarService.generateStatusChildEntity(houseMap[id], parent),
      );

      parent.p_children = children;
      return parent;
    });
  }

  private generateCalendarMapV3(calendar: any[]) {
    return mapValues(keyBy(calendar, "house_id"), (item, key) => {
      return mapValues(keyBy(item.calendar, "date"), (item) => {
        /** note 相关的交互依赖日历 item 中的 house_id, 但是新的接口没有这个数据了，所以这里手动添加上 */
        item.house_id = +key;
        // 生成价格和 rules 信息
        item.prices = item.prices.map((price) => {
          const { setting } = price;
          return {
            ...price,
            setting: setting
              ? {
                  ...setting,
                  showMoon:
                    setting.min_stay_on_arrival ||
                    setting.min_stay_through ||
                    setting.max_stay_on_arrival ||
                    setting.max_stay_through ||
                    setting.exact_stay_on_arrival,
                  moonCount: setting.min_stay_on_arrival || setting.min_stay_through,
                  showFlag: setting.min_advance_res || setting.max_advance_res || setting.seasonal_rule,
                  showLock: setting.closed_on_arrival || setting.closed_on_departure,
                }
              : null,
          };
        });

        return item;
      });
    });
  }

  private generateResvMapV3(resvs: any[]) {
    return mapValues(groupBy(resvs, "house_id"), (item) => {
      return mapValues(keyBy(item, "code"), (resv) => {
        const { check_in, check_out, out_status, reservation_order } = resv;
        const index = this.calendarService.offsetDays(this.calendarService.rangeStart, check_in);
        const nights = moment(check_out).diff(check_in, "days");

        return {
          ...resv,
          __index: index,
          __nights: nights,
          __before: out_status === "wait_stay",
          __checking: out_status === "staying",
          __after: out_status === "completed",
          __code: reservation_order?.reservation_code, // 入住单
          __orderCode: reservation_order?.code, // 订单
          __reservationCount: reservation_order?.reservation_count,
          __channelName: this.getChannelName(resv),
          __reservationBGColor: this.getReservationColor(resv),
        };
      });
    });
  }

  private generateResvMapV4(resvs: any) {
    return mapValues(groupBy(resvs, "house_id"), (items) =>
      items.map((resv) => {
        const { check_in, check_out, out_status, reservation_order } = resv;
        const index = this.calendarService.offsetDays(this.calendarService.rangeStart, check_in);
        const nights = moment(check_out).diff(check_in, "days");

        return {
          ...resv,
          __index: index,
          __nights: nights,
          __before: out_status === "wait_stay",
          __checking: out_status === "staying",
          __after: out_status === "completed",
          __code: reservation_order?.reservation_code, // 入住单
          __orderCode: reservation_order?.code, // 订单
          __reservationCount: reservation_order?.reservation_count,
          __channelName: this.getChannelName(resv),
          __reservationBGColor: this.getReservationColor(resv),
        };
      }),
    );
  }

  private generateHourResvMapV3(hourResvs: any[]) {
    return mapValues(groupBy(hourResvs, "house_id"), (item) => {
      return groupBy(item, "check_in");
    });
  }

  private generateTaskMapV3(tasks: any[]) {
    return mapValues(groupBy(tasks, "house_id"), (item) => {
      return groupBy(item, "expected_date");
    });
  }

  private updateFreeHouseCount(list: Array<any>) {
    this.freeHouseCountMap = _.keyBy(list, "date");
  }

  private updateFreeHouseCountByType(list: Array<any>) {
    const map = { ...this.freeHouseCountMapByType };
    _.forEach(list, (item) => {
      const { house_type_id: id, daily_can_sell: calendar } = item;

      const typeMap = map[id] || {};

      _.forEach(calendar, (c) => {
        const date = c.date;
        typeMap[date] = c.can_sell;
      });

      map[id] = typeMap;
    });
    this.freeHouseCountMapByType = map;
  }

  private updateChannelColorMap(list: Array<any>) {
    this.reservationChannelMap = _.keyBy(list, "code");
  }

  private updateReservationStyle(style) {
    this.reservationStyle = style === 0 ? "status" : "channel";
  }

  private updateDisplayPagination() {
    /**
     * 大屏幕下可以直接展示pagination
     * 小屏幕则需要根据滚动动态判断
     * */
    // const calendarContainer = this.calendar.calendarBody;
    const calendarContainer = this.calendar.calendarContainer;
    const scrollTop = calendarContainer.nativeElement.scrollTop;
    const clientHeight = calendarContainer.nativeElement.clientHeight;
    const scrollHeight = calendarContainer.nativeElement.scrollHeight;
    if (scrollHeight > clientHeight) {
      /** 有滚动条，并且未滚动到底部 */
      this.displayPagination = false;
    } else {
      this.displayPagination = true;
    }

    console.log("displayPagination: ", this.displayPagination);
  }

  private updateHouseOversaleMap(house_map: Array<any> = [], house_type_map: Array<any> = []) {
    const house = _.omitBy(
      _.mapValues(_.groupBy(house_map, "house_id"), (value) => _.get(value, [0, "new_allowed_overbooking"])),
      (v) => _.isEmpty(v),
    );
    const type = _.omitBy(
      _.mapValues(_.groupBy(house_type_map, "house_type_id"), (value) => _.get(value, [0, "new_allowed_overbooking"])),
      (v) => _.isEmpty(v),
    );
    // const houses = _.map(house_map, house => ({ [house.house_id]: house.allow_overbooking }));
    // const types = _.map(house_type_map, type => ({ [type.house_type_id]: type.allow_overbooking }));

    this.housesOversaleMap = { house, type };
  }

  private updateInventoryDiffMap(list: Array<any>) {
    const result = {};
    _.forEach(list, (item) => {
      const key = item.house_type_id;
      const value = item.list;
      _.assign(result, { [key]: value });
    });

    this.inventoryDiffMap = result;
  }

  private getChannelName(reservation) {
    if (reservation.thirdparty_type === 5) {
      /** 取渠道名 */

      // return this.translate.syncGet('word.channel_' + reservation.handmade_chanel);

      const channel = this.reservationChannelMap[reservation.handmade_chanel];
      if (channel) {
        return channel.channel_name;
      }
    } else {
      /** 取平台名 */
      return this.t.syncGet("word.channel_" + reservation.thirdparty_type);
    }
  }

  private getReservationColor(reservation) {
    if (this.reservationStyle === "channel") {
      const code = reservation.handmade_chanel;
      const channel = this.reservationChannelMap[code];
      return channel ? channel.bg_color : "#B9B9B9";
    } else {
      /** 按状态显示订单颜色 */
      return reservation.out_status === "wait_stay"
        ? "#52A06B"
        : reservation.out_status === "staying"
          ? "#D85F7C"
          : "#4C83BF";
    }
  }

  displayDepositModal() {
    this.globalModalService.displayDepositModal();
  }

  displayWidgetModal(type: "today" | "tomorrow" | "box" = "today") {
    const title = {
      today: this.t.syncGet("house.today_task_count", {
        count: this.widgetCount.today_task_count,
      }),
      tomorrow: this.t.syncGet("house.tomorrow_task_count", {
        count: this.widgetCount.tomorrow_task_count,
      }),
      box: this.t.syncGet("house.orderbox_task_count", {
        count: this.widgetCount.box_count,
      }),
      // today: `今日任务（${this.widgetCount.today_task_count}）`,
      // tomorrow: `明日任务（${this.widgetCount.tomorrow_task_count}）`,
      // box: `订单盒子（${this.widgetCount.box_count}）`
    }[type];
    const component: Type<any> = {
      today: HouseTodayComponent,
      tomorrow: HouseTomorrowComponent,
      box: HouseOrderboxComponent,
    }[type];

    const modal = this.modal.create({
      nzTitle: title,
      nzWidth: 980,
      nzContent: component,
      nzFooter: null,
    });

    modal.afterClose.subscribe(() => {
      this.fetchCalendarV3();
      // this.fetchCalendarList();
      this.fetchWidgetCount();
    });
  }

  //#region Signal Refactor
  onDatesChange(date: [string, string]) {
    console.log("hostex status: on Dates change");
    this.begin = head(date);
    this.end = last(date);
    this.filterForm.patchValue({ month: moment(this.begin).format("YYYY-MM") }, { emitEvent: false });

    this.fetchCalendarV3();
    this.fetchFreeHouseCountByHouseType();
    this.fetchInventoryDiffInfo();
  }

  onJumpToDate(value) {
    this.layoutSrv.jumpToDate(value);
  }

  //#endregion

  //#region Share Calendar

  displayShareSuccessModal = false;

  onClickShare(type: "entire" | "partial" | "link") {
    switch (type) {
      case "entire":
        // this.displayShareEntireModal();
        this.requestCreateShareLink("entire");
        break;
      case "partial":
        this.displaySharePartialModal();
        break;
      case "link":
        this.displayManageShareLinkModal();
        break;
    }
  }

  private displayShareLinkSuccessInfo() {
    this.displayShareSuccessModal = true;
    // return;
    // this.modal.confirm({
    //   nzWidth: 600,
    //   // nzTitle: null,
    //   nzTitle: this.t.t("status-calendar_html_shared_success_title"),
    //   // nzContent: `
    //   //   <div class="text-center">
    //   //     <img src="/assets/icon/status-success.png" />
    //   //     <div class="mt-[30px] text-l">${this.t.t("status-calendar_html_shared_success_title")}</div>
    //   //   </div>
    //   // `,
    //   nzClosable: false,
    //   nzIconType: "check-circle",
    //   nzMaskClosable: true,
    //   nzCancelText: this.t.t("status-calendar_html_shared_success_link"),
    //   nzOnCancel: (t) => {
    //     console.log("t: ", t);

    //     this.displayManageShareLinkModal();
    //   },
    //   nzFooter: [
    //     {
    //       label: this.t.t("status-calendar_html_shared_success_link"),
    //     },
    //     {
    //       label: this.t.t("word.confirm"),
    //       type: "primary",
    //     },
    //   ],
    // });
  }

  private displaySharePartialModal() {
    const modal = this.modal.create({
      nzWidth: 800,
      nzContent: V4HousesModalSelectComponent,
      nzFooter: null,
    });
    modal.afterClose.subscribe((rst) => {
      console.log("rst: ", rst);
      const { status, data } = rst;
      if (status === "ok" && data.length) {
        this.requestCreateShareLink("partial", data?.map((item) => item.value));
      }
    });
  }

  displayManageShareLinkModal() {
    this.modal.create({
      nzWidth: 900,
      nzTitle: this.t.t("status-calendar-operate_bar_html_share_manage"),
      nzContent: ShareLinkComponent,
      nzFooter: null,
    });
  }

  private requestCreateShareLink(type: "entire" | "partial", houseIds?) {
    const params = {
      type,
      house_ids: houseIds,
    };
    this.http.post("/api/calendar_share/create", params).subscribe((rst: any) => {
      if (rst?.error_code === 0) {
        navigator.clipboard?.writeText(rst.data.link);
        this.displayShareLinkSuccessInfo();
      }
    });
  }

  //#endregion

  // hasWritePermission() {
  //   return this.authorityService.hasWritePermission('calendar');
  // }

  onPageChange() {
    this.requestHouseList().subscribe(() => {
      this.fetchCalendarV3();
      this.fetchFreeHouseCountByHouseType();
      this.fetchInventoryDiffInfo();
    });

    // await this.fetchHouseAndCalendar();
  }

  @WritePermissionGurd("calendar")
  onClickChangeAvailable(data) {
    // if (!this.hasWritePermission()) {
    //   this.modalService.warning({
    //     nzTitle: "暂无修改权限，请联系管理员"
    //   });
    //   return;
    // }
    this.houseCalendarService.requestUpdateAvailable(data.status);
    // this.requestChangeHouseAvailable(data);
  }

  @WritePermissionGurd("calendar")
  onClickChangeTab(name) {
    // if (!this.hasWritePermission()) {
    //   this.modalService.warning({
    //     nzTitle: "暂无修改权限，请联系管理员"
    //   });
    //   return;
    // }
    this.houseCalendarService.changeTab(name);
    this.type = "hostex";
  }

  @WritePermissionGurd("calendar")
  onClickSetHouseTypeInventory(params) {
    // if (!this.hasWritePermission()) {
    //   this.modalService.warning({
    //     nzTitle: "暂无修改权限，请联系管理员"
    //   });
    //   return;
    // }
    this.requestSetHouseTypeInventory(params);
  }

  @WritePermissionGurd("calendar")
  onClickSaveEditNote(params) {
    let request$;
    if (!params.note && params.note !== 0) {
      request$ = this.requestDeleteNote(params);
    } else {
      request$ = this.requestAddNote(params);
    }
    request$.subscribe(() => {
      this.fetchCalendarV3();
    });
  }

  onClickUpdateCleanStatus(data) {
    this.requestUpdateCleanStatus(data)
      .pipe(switchMap(() => this.requestHouseList()))
      .subscribe();
  }

  onChangeOrderBelongedHouse(params) {
    this.orderService.setChangeToHouse(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.fetchHouseAndCalendar();
      }
    });
  }

  onClickExtendStay(code) {
    const modal = this.modal.create({
      nzTitle: this.t.t("order.continue_stay"),
      nzContent: ContinueStayComponent,
      nzFooter: null,
      nzWidth: 390,
      /** @deprecated */
      nzComponentParams: {
        reservation_code: code,
        type: "single",
      },
      nzData: {
        reservation_code: code,
        type: "single",
      },
    });

    modal.afterClose.subscribe((res) => {
      if (res && res.refresh) {
        this.fetchCalendarV3();
        // this.fetchCalendarList();
      }
    });
  }

  onClickCreateTask(data) {
    const modal = this.globalModalService.displayCreateTaskModal({
      expected_date: data.date,
      house_id: data.houseId,
      // house: { id: data.houseId },
    });

    modal.afterClose.subscribe((res) => {
      this.fetchCalendarV3();
      // this.fetchCalendarList();
    });
  }

  onToggleDisplayLeadView(view: "price" | "rules", value: boolean) {
    if (view === "price") {
      this.displayLeadPrice = value;
    } else {
      this.displayLeadRules = value;
    }

    this.cacheLeadView(view, value);
  }

  private displayTaskDetailDrawer(task) {
    console.log("task: ", task);
    this.createTaskDrawerRef?.close();
    const title = this.t.t(`task.word.type.type_${task.type}`) + this.dateSrv.format(task.expected_date, ["MD"]);

    const ref = this.drawer.create({
      nzTitle: title,
      nzContent: TaskDetailComponent,
      nzWidth: 500,
      nzMask: false,
      nzMaskClosable: false,
      nzContentParams: {
        taskId: task.id,
        houseId: task.house_id,
        date: task.expected_date,
      },
    });

    ref.afterClose.subscribe(() => {
      this.fetchCalendarV3();
      // this.fetchCalendarList();
    });

    this.createTaskDrawerRef = ref;
  }

  // onCloseTaskSidebar() {
  //   this.selectedTask = null;
  //   this.fetchCalendarList();
  // }

  toBlogPage() {
    this.modal.closeAll();
    window.open("https://www.yuque.com/baijuyi_help/web/ical_close");
  }

  @WritePermissionGurd("calendar")
  onSyncReservations() {
    // if (!this.hasWritePermission()) {
    //   this.modalService.warning({
    //     nzTitle: "暂无修改权限，请联系管理员"
    //   });
    //   return;
    // }
    this.modal.create({
      nzWidth: 786,
      nzTitle: this.t.syncGet("calendar.sync_order"),
      nzContent: ReadOrdersComponent,
      nzFooter: null,
    });
    // this.statusService.syncManual({});
  }

  filter(field: FilterField, value) {
    this.filterRaw$.next({ field, value });
  }

  scroll(value: number | string | Moment = moment()) {
    console.log("value: ", value);
    this.scrollRaw$.next(value);

    this.layoutSrv.jumpToDate(value as any);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();

    this.hostexSiderbarDrawerRef?.close();
    this.hourResvDrawerRef?.close();
    this.resvDetailDrawerRef?.close();

    this.headerOutletInstance?.destroyComponent();
  }
}
